<app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
<nav class="navbar navbar-user navbar-expand-lg bg-black navbar-dark fixed-top">
  <div class="container-fluid">
    <div class="d-flex flex px-1" id="navbarSupportedContent" style="flex:1;">
      <ul class="navbar-nav">
        <li>
          <a [routerLink]="['/dashboard']" boundariesElement="viewport" container="body">
            <img src="/assets/icons/device-fav.svg" alt="Yo Scenario logo" width="32" />
          </a>
        </li>
      </ul>
      <a [routerLink]="['/dashboard']" style=" text-decoration: none;"><div class="navbar-brand my-0 py-0 ms-2 small" style="font-size:1.25rem;">Scenario Library</div></a>

      <div class="d-flex align-items-center ms-0 	d-none d-sm-flex">
        <div *ngIf="!scenario && activeScenario">
          <button type="button" class="btn btn-dark btn-sm d-flex ms-3" [routerLink]="['/steps',activeScenario.id]">
            
            <i class="bx bx-chevron-left btn-icon  me-1"></i>{{ activeScenario.title }}
          </button>
        </div>
        <div dropdown *ngIf="scenarios && scenario" container="body">
          <button id="button-scenarios-dropdown" dropdownToggle type="button" class="btn btn-dark btn-sm d-flex ms-3"
            aria-controls="dropdown-scenarios">
            <i class="bx bx-windows btn-icon me-1"></i>
            {{ scenario.title }}
          </button>
          <ul id="dropdown-scenarios" *dropdownMenu class="dropdown-menu dropdown-menu-scroll dropdown-menu-sm"
            role="menu" aria-labelledby="button-scenarios-dropdown">
            <li role="menuitem" *ngFor="let _scenario of scenarios">
              <a class="dropdown-item pointer" [ngClass]="{ active: _scenario.scenario_id == scenario.id }"
                (click)="onGoToScenario(_scenario.scenario_id)">{{ _scenario.title }}</a>
            </li>
          </ul>
        </div>

        <!-- step -->
        <ng-container *ngIf="step">
          <div class="mx-1 text-light">
            <i class="bx bx-chevron-right fs-4"></i>
          </div>
          <div class="mx-1 text-light">
            <i class="bx bx-sitemap fs-4"></i>
          </div>
          <div>
            <input type="text" *ngIf="step" [(ngModel)]="step.title" id="step-title-input step-title-input-sm"
              class="form-control-minimal form-control-minimal-dark fs-6" (input)="onChangeTitle()" placement="bottom"
              containerClass="tooltip-inverse" style="width: {{ step?.title?.length + 3 }}ch;" />
          </div>
        </ng-container>
        <ng-container *ngIf="page && scenarios && scenario">
          <div class="mx-1 text-light">
            <i class="bx bx-chevron-right fs-4"></i>
          </div>
          <div class="text-light" *ngIf="!page.title">
            {{ page }}
          </div>
          <div class="text-light" *ngIf="page.title">
            <a [routerLink]="page.link" class="text-light">{{ page.title }}</a>
          </div>
        </ng-container>
        <ng-container *ngIf="subpage && scenarios && scenario">
          <div class="mx-1 text-light">
            <i class="bx bx-chevron-right fs-4"></i>
          </div>
          <div class="text-light">
            {{ subpage }}
          </div>
        </ng-container>

        <!-- end step -->
      </div>

      
      <ul class="navbar-nav ms-auto navbar-global flex-row align-items-center">
        <li [ngClass]="{ active: active == 'dashboard' }" *ngIf="currentUser">
          <button class="btn" [routerLink]="['/dashboard']">
            <i class="bx bx-library btn-icon"></i> <span class="d-none d-md-inline">My Library</span>
          </button>
        </li>
        <li [ngClass]="{ active: active == 'results' }" *ngIf="currentUser">
          <button class="btn" [routerLink]="['/results']">
            <i class='bx bxs-bar-chart-alt-2 btn-icon'></i> <span class="d-none d-md-inline">Results</span>
          </button>
        </li>


        <li [ngClass]="{ active: active == 'admin' }" *ngIf="currentUser && currentUser.user_id == 1">
          <button class="btn" [routerLink]="['/admin']">
            <i class='bx bxs-cog btn-icon'></i> <span class="d-none d-md-inline">Admin</span>
          </button>
        </li>


        <li #dp="bs-dropdown" dropdown *ngIf="currentUser">
          <button class="btn" tabindex="0" id="button-alignment" dropdownToggle type="button"
            aria-controls="dropdown-alignment">
            <i class="bx bxs-user-circle btn-icon"></i> <span class="d-none d-md-inline"></span> {{userData.first_name}} {{userData.last_name}}
          </button>

          <ul id="dropdown-alignment" *dropdownMenu class="dropdown-menu dropdown-menu-end">

            <!--li *ngIf="!currentUser?.sso_mode" role="menuitem">
              <a class="dropdown-item" [routerLink]="['/update-details']" class="dropdown-item py-1"><i
                  class="bx bx-fw bxs-shopping-bag"></i>
                Purchase history</a>
            </li-->
            <li *ngIf="!currentUser?.sso_mode" role="menuitem">
              <a class="dropdown-item" [routerLink]="['/update-details']" class="dropdown-item py-1"><i
                  class="bx bx-fw bxs-user-badge"></i>
                Update Details</a>
            </li>
            <li *ngIf="!currentUser?.sso_mode" role="menuitem">
              <a class="dropdown-item" [routerLink]="['/change-password']" class="dropdown-item py-1"><i
                  class="bx bx-fw bxs-key"></i>
                Change Password</a>
            </li>
            <li>
              <a (click)="onLogout()" class="pointer dropdown-item py-1" tabindex="0"><i
                  class="bx bx-fw bx-log-out"></i>
                Log Out</a>
            </li>
          </ul>
        </li>
        
      </ul>
    </div>
  </div>
</nav>